import useMutate from '../../hooks/api/useMutate';

export function useStripeOnboard() {
  const { post } = useMutate('/stripe/connect/onboard');
  const startOnboarding = () => post({});
  return { startOnboarding };
}

export function useInitiateLocationCheckout() {
  const { post } = useMutate('/subscription/location-checkout');
  const startCheckout = () => post({});
  return { startCheckout };
}
